import React from 'react';
import { useIntl } from 'react-intl';

import {
    CSSEditor,
    CSSEditorComponentLabel,
    CSSEditorComponentWrapper,
    CSSEditorWidgetProperties,
} from 'components/Editors/components/Editor.style';
import { EditorColorPicker } from 'components/Editors/components/EditorColorPicker';

import { EditorSelect } from 'components/Editors/components/EditorSelect';

import { EditorColorsOptions, EditorRadiusOptions } from '../const';
import { JRCWidgetTableProps } from './JRCWidgetTable';

export const JRCWidgetTableEditor = ({
    limit,
    tableHeadColor,
    tableHeadTextColor,
    tableRowColor,
    tableRowTextColor,
    onChange,
}: JRCWidgetTableProps & {
    onChange: (content: Partial<JRCWidgetTableProps>) => void;
}) => {
    const intl = useIntl();

    return (
        <CSSEditor>
            <CSSEditorWidgetProperties>
                <CSSEditorComponentWrapper>
                    <CSSEditorComponentLabel>
                        {intl.formatMessage({ id: 'PANEL_Background_Color' })}
                    </CSSEditorComponentLabel>
                    <EditorColorPicker
                        colors={EditorColorsOptions}
                        initialValue={tableHeadColor}
                        onChange={(tableHeadColor) => onChange({ tableHeadColor })}
                    />
                </CSSEditorComponentWrapper>
                <CSSEditorComponentWrapper>
                    <CSSEditorComponentLabel>{intl.formatMessage({ id: 'PANEL_Text_Color' })}</CSSEditorComponentLabel>
                    <EditorColorPicker
                        colors={EditorColorsOptions}
                        initialValue={tableHeadTextColor}
                        onChange={(tableHeadTextColor) => onChange({ tableHeadTextColor })}
                    />
                </CSSEditorComponentWrapper>
                <CSSEditorComponentWrapper>
                    <CSSEditorComponentLabel>
                        {intl.formatMessage({ id: 'PANEL_Background_Color' })}
                    </CSSEditorComponentLabel>
                    <EditorColorPicker
                        colors={EditorColorsOptions}
                        initialValue={tableRowColor}
                        onChange={(tableRowColor) => onChange({ tableRowColor })}
                    />
                </CSSEditorComponentWrapper>
                <CSSEditorComponentWrapper>
                    <CSSEditorComponentLabel>{intl.formatMessage({ id: 'PANEL_Text_Color' })}</CSSEditorComponentLabel>
                    <EditorColorPicker
                        colors={EditorColorsOptions}
                        initialValue={tableRowTextColor}
                        onChange={(tableRowTextColor) => onChange({ tableRowTextColor })}
                    />
                </CSSEditorComponentWrapper>
                <CSSEditorComponentWrapper>
                    <EditorSelect
                        label={intl.formatMessage({ id: 'PANEL_Limit' })}
                        options={EditorRadiusOptions}
                        initialValue={String(limit)}
                        onChange={(limit) => onChange({ limit: Number(limit) })}
                    />
                </CSSEditorComponentWrapper>
            </CSSEditorWidgetProperties>
        </CSSEditor>
    );
};
